webpackJsonp([6,4],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(90);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _cov = __webpack_require__(31);
	
	var _cov2 = _interopRequireDefault(_cov);
	
	var _router = __webpack_require__(32);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.debug = true;
	
	var $root = null;
	
	_vue2.default.prototype.$Cov = {
	    setRoot: function setRoot(vm) {
	        $root = vm;
	    },
	    hideGlobalNav: function hideGlobalNav() {
	        $root.state.globalNavShow = false;
	    },
	    showGlobalNav: function showGlobalNav() {
	        $root.state.globalNavShow = true;
	    }
	};
	
	var swiper = new _cov2.default();
	_vue2.default.prototype.$swipe = swiper;
	
	_router2.default.start(_App2.default, 'app');

/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(39);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(41);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(42);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(43);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cov = function () {
	    function Cov() {
	        (0, _classCallCheck3.default)(this, Cov);
	
	        this._hasTouch = 'ontouchstart' in window;
	        this.init();
	        this.touch = {
	            start: null,
	            end: null
	        };
	        this.state = {
	            swiping: false,
	            global: false
	        };
	        this.queue = {
	            'swiping': [],
	            'swiped': [],
	            'swipe-left': [],
	            'swipe-right': [],
	            'swipe-up': [],
	            'swipe-down': []
	        };
	    }
	
	    (0, _createClass3.default)(Cov, [{
	        key: 'init',
	        value: function init() {
	            if (this._hasTouch) {
	                window.document.body.addEventListener('touchstart', this.touchStart.bind(this), false);
	                window.document.body.addEventListener('touchmove', this.touchMove.bind(this), false);
	                window.document.body.addEventListener('touchend', this.touchEnd.bind(this), false);
	                window.document.body.addEventListener('touchcancel', this.touchCancel.bind(this), false);
	            }
	        }
	    }, {
	        key: 'setGlobal',
	        value: function setGlobal() {
	            this.state.global = true;
	        }
	    }, {
	        key: 'cancelGlobal',
	        value: function cancelGlobal() {
	            this.state.global = false;
	        }
	    }, {
	        key: 'listen',
	        value: function listen(type, $el, func) {
	            var rect = void 0;
	            if (!$el) {
	                rect = null;
	            } else {
	                var tmp = $el.getBoundingClientRect();
	                rect = {
	                    x: tmp.left,
	                    y: tmp.top,
	                    width: tmp.width,
	                    height: tmp.height
	                };
	            }
	
	            var token = Math.random() * 9999 + type;
	            this.queue[type].push({
	                $el: $el,
	                token: token,
	                func: func,
	                rect: rect
	            });
	        }
	    }, {
	        key: 'leave',
	        value: function leave(type, token) {
	            if (!this.queue[type]) return false;
	            for (var i = 0, len = this.queue[type].length; i < len; i++) {
	                if (this.queue[type].token === token) {
	                    this.queue[type].splice(i - 1, 1);
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: 'update',
	        value: function update() {
	            var keys = (0, _keys2.default)(this.queue);
	            var tmp = void 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = (0, _getIterator3.default)(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var key = _step.value;
	
	                    this.queue[key].forEach(function (item) {
	                        if (item.$el) {
	                            tmp = item.$el.getBoundingClientRect();
	                            item.rect = {
	                                x: tmp.left,
	                                y: tmp.top,
	                                width: tmp.width,
	                                height: tmp.height
	                            };
	                        }
	                    });
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            var keys = (0, _keys2.default)(this.queue);
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _getIterator3.default)(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var key = _step2.value;
	
	                    this.queue[key].length = 0;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'notice',
	        value: function notice(type, rect) {
	            var rectTmp = {};
	            var once = true;
	            var tmpFunc = null;
	            for (var i = 0, len = this.queue[type].length; i < len; i++) {
	                rectTmp = this.queue[type][i].rect;
	                if (!rectTmp) {
	                    tmpFunc = this.queue[type][i].func;
	                } else {
	                    if (this.rectIn(rect, rectTmp) && !this.state.global) {
	                        this.queue[type][i].func(this.touch.start, this.touch.end);
	                        once = false;
	                    }
	                }
	            }
	            if (once && tmpFunc) {
	                tmpFunc(this.touch.start, this.touch.end);
	            }
	        }
	    }, {
	        key: 'rectIn',
	        value: function rectIn(small, big) {
	            if (small.x > big.x && small.x + small.width < big.x + big.width && small.y > big.y && small.y + small.height < big.y + big.height) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'getRect',
	        value: function getRect(dot1, dot2) {
	            var rect = {};
	
	            if (dot1.x < dot2.x) {
	                rect.x = dot1.x;
	                rect.width = dot2.x - dot1.x;
	            } else {
	                rect.x = dot2.x;
	                rect.width = dot1.x - dot2.x;
	            }
	
	            if (dot1.y < dot2.y) {
	                rect.y = dot1.y;
	                rect.height = dot2.y - dot1.y;
	            } else {
	                rect.y = dot2.y;
	                rect.height = dot1.y - dot2.y;
	            }
	            return rect;
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(e) {
	            var len = e.touches.length;
	            var poss = [];
	            for (var i = 0; i < len; i++) {
	                poss.push({
	                    x: e.touches[i].pageX,
	                    y: e.touches[i].pageY
	                });
	            }
	            return poss;
	        }
	    }, {
	        key: 'getDistance',
	        value: function getDistance(dot1, dot2) {
	            return Math.sqrt(Math.pow(dot1.x - dot2.x, 2) + Math.pow(dot1.y - dot2.y, 2));
	        }
	    }, {
	        key: 'getAngle',
	        value: function getAngle(dot1, dot2) {
	            return Math.atan2(dot2.y - dot1.y, dot2.x - dot1.x) * 180 / Math.PI;
	        }
	    }, {
	        key: 'touchStart',
	        value: function touchStart(e) {
	            e.preventDefault();
	            this.state.swiping = true;
	            this.touch.start = this.getPosition(e)[0];
	        }
	    }, {
	        key: 'touchMove',
	        value: function touchMove(e) {
	            e.preventDefault();
	            this.touch.end = this.getPosition(e)[0];
	            this.notice('swiping', this.getRect(this.touch.end, this.touch.start));
	        }
	    }, {
	        key: 'touchEnd',
	        value: function touchEnd(e) {
	            e.preventDefault();
	            this.notice('swiped', this.getRect(this.touch.end, this.touch.start));
	            this.state.swiping = true;
	            var angle = this.getAngle(this.touch.end, this.touch.start);
	            if (angle > -45 && angle < 45) {
	                this.notice('swipe-left', this.getRect(this.touch.end, this.touch.start));
	            }
	            if (angle < -135 || angle > 135) {
	                this.notice('swipe-right', this.getRect(this.touch.end, this.touch.start));
	            }
	            if (angle > 45 && angle < 135) {
	                this.notice('swipe-up', this.getRect(this.touch.end, this.touch.start));
	            }
	            if (angle < -45 && angle > -135) {
	                this.notice('swipe-down', this.getRect(this.touch.end, this.touch.start));
	            }
	        }
	    }, {
	        key: 'touchCancel',
	        value: function touchCancel(e) {
	            e.preventDefault();
	            console.log(e);
	        }
	    }]);
	    return Cov;
	}();
	
	exports.default = Cov;

/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(96);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default();
	
	router.map({
	    '/message': {
	        name: 'message',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(95)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/contact': {
	        name: 'contact',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(93)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/infocenter': {
	        name: 'infocenter',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(94)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    },
	    '/chat': {
	        name: 'chat',
	        component: function component(resolve) {
	            __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(92)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	    }
	});
	
	router.redirect({
	    '/': '/message'
	});
	
	exports.default = router;

/***/ },

/***/ 33:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            state: {
	                slideNavShow: false,
	                globalNavShow: true
	            }
	        };
	    },
	    created: function created() {
	        this.$Cov.setRoot(this);
	    }
	};

/***/ },

/***/ 78:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 84:
/***/ function(module, exports) {

	module.exports = " <div id=app :class=\"{ \n        'slide-active': state.slideNavShow,\n        'without-bottom-nav': !state.globalNavShow\n        }\"> <router-view></router-view> <div class=slide-nav> <div class=cov-slide-user> <div class=cov-slide-avatar></div> <div class=cov-slide-user-info> <div class=cov-slide-user-name>Awe</div> <div class=cov-slide-user-level> <div class=\"cov-slide-user-level-icon sun\"></div> <div class=cov-slide-user-level-icon></div> </div> </div> </div> </div> <nav class=cov-nav-bar v-show=state.globalNavShow> <div class=cov-nav-bar-item v-link=\"{ name: 'message', activeClass: 'active'}\"> <span>消息</span> </div> <div class=cov-nav-bar-item v-link=\"{ name: 'contact', activeClass: 'active'}\"> <span>联系人</span> </div> <div class=cov-nav-bar-item v-link=\"{ name: 'infocenter', activeClass: 'active'}\"> <span>动态</span> </div> </nav> </div> ";

/***/ },

/***/ 90:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(78)
	__vue_script__ = __webpack_require__(33)
	__vue_template__ = __webpack_require__(84)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.f69bb92e098858c908e9.js
 **/